import { Outlet, Navigate } from "react-router-dom";
import { TOKEN } from "./constants";

const PrivateRoutes = ({ token }) => {
  let temp = localStorage.getItem(TOKEN);
  return token || temp ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
